import firebase from "firebase/app";
//import "firebase/database";
//import app from 'firebase/app';
//import 'firebase/auth';

var config = {
  apiKey: "AIzaSyAl1oiTE9w67N8MSTp4zn4rFgt77a992hU",
  authDomain: "smedia-b29c0.firebaseapp.com",
  databaseURL: "https://smedia-b29c0.firebaseio.com",
  projectId: "smedia-b29c0",
  storageBucket: "smedia-b29c0.appspot.com",
  messagingSenderId: "752172327465",
  appId: "1:752172327465:web:64594e0e7fe14c7f71f238",
  measurementId: "G-4SD9NWMS59",
};

firebase.initializeApp(config);
//const db = fireApp.firestore()
export default firebase;

// class firebaseConn {
//   constructor() {
//     firebase.initializeApp(config);
//     this.users = firebase.remoteConfig("/users");
//     this.auth = firebase.auth();
//     console.log ("fb conn ",this.auth);
//   }

//   // *** Auth API ***

//   getAllUsers(){
//     return this.users;
//   }

//   doCreateUserWithEmailAndPassword = (email, password) =>
//     this.auth.createUserWithEmailAndPassword(email, password);

//   doSignInWithEmailAndPassword = (email, password) =>
//     this.auth.signInWithEmailAndPassword(email, password);

//   doSignOut = () => this.auth.signOut();

//   doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

//   doPasswordUpdate = password =>
//     this.auth.currentUser.updatePassword(password);
// }

// export default firebase;
// export {firebaseConn};
